import React from "react"
import { Form, Button } from "react-bootstrap"

const VideoSectionForm = ({
  fields,
  onInputChange,
  validationErrors,
  setValidationErrors,
  section = "videoSection",
}) => {
  const handleInputChange = (key, value) => {
    onInputChange(section, key, value)
    if (validationErrors[`${section}.${key}`]) {
      setValidationErrors((prev) => ({
        ...prev,
        [`${section}.${key}`]: undefined,
      }))
    }
  }

  const handleVideoLinkChange = (index, value) => {
    const videoLinks = [...(fields.videoLinks || [])]
    videoLinks[index] = value
    handleInputChange("videoLinks", videoLinks)
  }

  const handleAddVideoLink = () => {
    const videoLinks = [...(fields.videoLinks || []), ""]
    handleInputChange("videoLinks", videoLinks)
  }

  const handleRemoveVideoLink = (index) => {
    const videoLinks = [...(fields.videoLinks || [])]
    videoLinks.splice(index, 1)
    handleInputChange("videoLinks", videoLinks.length ? videoLinks : [""])
  }

  const videoLinks = fields.videoLinks?.length ? fields.videoLinks : [""]

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>
          Heading {fields.isVisible && <span className="text-danger">*</span>}
        </Form.Label>
        <Form.Control
          type="text"
          placeholder={`Heading ${fields.isVisible ? "*" : ""}`}
          value={fields.heading || ""}
          onChange={(e) => handleInputChange("heading", e.target.value)}
          isInvalid={!!validationErrors[`${section}.heading`]}
        />
        {validationErrors[`${section}.heading`] && (
          <Form.Control.Feedback type="invalid">
            {validationErrors[`${section}.heading`]}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <h6 className="fw-bold">YouTube Video URLs</h6>
      {videoLinks.map((link, idx) => (
        <div key={idx} className="d-flex gap-2 mb-2 align-items-start">
          <Form.Control
            type="url"
            placeholder="https://www.youtube.com/watch?v=..."
            value={link || ""}
            onChange={(e) => handleVideoLinkChange(idx, e.target.value)}
          />
          <Button
            variant="outline-danger"
            size="sm"
            onClick={() => handleRemoveVideoLink(idx)}
            disabled={videoLinks.length === 1}
          >
            Remove
          </Button>
        </div>
      ))}
      <Button variant="outline-primary" size="sm" onClick={handleAddVideoLink}>
        + Add Video URL
      </Button>
    </>
  )
}

export default VideoSectionForm
